/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure
} from '@chakra-ui/react'
import React, { useContext, useEffect, useState } from 'react'
import { ButtonStyled } from 'styled/Buttons.styled'
import { RiSearch2Line } from 'react-icons/ri'
import { useForm } from 'hooks/useForm'
import { AlertErrorAlert } from 'components/Alerts/AlertErrorAlert'
import GlobalContext from 'context/GlobalContext'
import environment from 'constants/apiConst'
import { SearchItemDispacth } from './SearchItemDispacth'
import { useMutation } from '@tanstack/react-query'
import FormInfo from 'components/DispatchCorrections/FormInfo'
import {
  FormItemsTemplate,
  errorMessageMap,
  regexPatterns
} from 'components/DispatchCorrections/Templates'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import { useDebounceErrorHandling } from 'hooks/useDebounceError'
import { ItemSearchModal } from './ItemSearchModal'

const EditTemplateValueItems = {
  id: '',
  item: '',
  outputForm_id: '',
  code_outputForm: '',
  quantity_go_out: '',
  outputFormItem_id: '',
  quantity_go_out_product: '',
  convertion_factor_product: '',
  code_businessUnit_corrected: '',
  output_form_item_description: '',
  // Corrected
  item_corrected: '',
  reference_corrected: '',
  item_output_corrected: '',
  description_corrected: '',
  code_product_corrected: '',
  outputFormCorrected_id: '',
  code_outputForm_corrected: '',
  quantity_go_out_corrected: '',
  outputFormItemCorrected_id: '',
  quantity_dispatch_corrected: '',
  quantity_go_out_product_corrected: '',
  quantity_dispatch_product_corrected: '',
  output_form_item_description_corrected: ''
}

export const AddItemsDispatch = ({ editType, ...props }) => {
  const [openAlert] = AlertErrorAlert()
  const [isLoading, setIsLoading] = useState(false)

  const {
    targetData,
    actionToBeCarriedOut,
    performStatusChange,
    setActionToBeCarriedOut,
    setTargetData,
    setUpdate
  } = useContext(GlobalContext)
  const {
    isOpen: isOpenSearchItem,
    onOpen: onOpenSearchItem,
    onClose: onCloseSearchItem
  } = useDisclosure()
  const location = useLocation()
  const [handleDebounceRegexError] = useDebounceErrorHandling()

  const { Action = '', Dispatch: DispatchCorrectionID = null } =
    queryString.parse(location.search)

  const [values, handleInputChange, reset, setValues] = useForm(
    EditTemplateValueItems
  )

  const handleRegex = ({ target }) => {
    const typeRegex = target?.dataset?.typeRegex || 'anythingGoes'
    const regexConf = regexPatterns[typeRegex]

    const { value } = target
    let errorMessage = null

    if (!regexConf.test(value)) {
      if (typeRegex !== 'anythingGoes') {
        errorMessage = `Este campo solo acepta ${errorMessageMap[typeRegex]}`
      } else if (value.length > 0) {
        errorMessage = `El carácter ${value[value.length - 1]
        } no es permitido en este campo`
      }
    }

    handleDebounceRegexError(
      { target },
      handleInputChange,
      errorMessage,
      regexConf
    )
  }

  const { mutate, isLoading: isLoadingPost } = useMutation({
    mutationFn: performStatusChange,
    retry: 3
  })

  useEffect(() => {
    if (targetData) {
      const filterAndNormalizeData = Object.keys(targetData).reduce(
        (acc, key) => {
          const value = targetData[key]
          acc[key] = value !== null && value !== undefined ? value : ''
          return acc
        },
        {}
      )
      setValues(filterAndNormalizeData)
    }
  }, [targetData])

  const validateFormData = () => {
    const errors = []

    // Validar item de salida
    if (!values?.outputFormItemCorrected_id) {
      errors.push('Debe seleccionar un item de salida')
    }

    // Validar cantidad despachada
    const quantityDispatch = parseFloat(values?.quantity_dispatch_corrected)
    if (quantityDispatch < 0) {
      console.log('quantityDispatch', quantityDispatch);
      errors.push('La cantidad despachada debe ser un número mayor o igual a 0')
    }

    // Validar cantidad producto despachada
    const quantityDispatchProduct = parseFloat(values?.quantity_dispatch_product_corrected)
    if (quantityDispatchProduct < 0) {
      console.log('quantityDispatchProduct', quantityDispatchProduct);
      errors.push('La cantidad producto despachada debe ser un número mayor o igual a 0')
    }

    // Validar DispatchCorrectionID para operaciones de creación
    if (actionToBeCarriedOut === 'Create' && !DispatchCorrectionID) {
      errors.push('ID de corrección de despacho no encontrado')
    }

    return errors
  }

  const buildRequestData = () => {
    const baseData = {
      outputFormItemCorrected_id: values?.outputFormItemCorrected_id,
      quantity_go_out_corrected: parseFloat(values?.quantity_dispatch_corrected),
      quantity_go_out_product_corrected: parseFloat(values?.quantity_dispatch_product_corrected),
      item_output_corrected: values?.item_output_corrected || '',
      reference: values?.reference_corrected || '',
      code_product_corrected: values?.code_product_corrected || '',
      code_businessUnit_corrected: values?.code_businessUnit_corrected || '',
      output_form_item_description_corrected: values?.output_form_item_description_corrected || ''
    }

    if (actionToBeCarriedOut === 'Edit') {
      return {
        id: values?.id,
        ...baseData
      }
    }

    return {
      dispatchPassCorrected_id: DispatchCorrectionID,
      ...baseData
    }
  }

  const handleSuccess = (data) => {
    const responseCode = data?.data?.status?.code
    const responseMessage = data?.data?.status?.message

    if (responseCode === 400) {
      openAlert(responseMessage || 'Error en la operación', 'error')
      return
    }

    if (responseCode === 200) {
      const actionText = actionToBeCarriedOut === 'Edit' ? 'actualizado' : 'creado'
      openAlert(responseMessage || `Registro ${actionText} exitosamente`, 'success')
      
      // Limpiar el formulario y estados
      setUpdate('updatedItems')
      setActionToBeCarriedOut('')
      setTargetData(null)
      reset()
    } else {
      openAlert(responseMessage || 'Respuesta inesperada del servidor', 'error')
    }
  }

  const handleError = (error) => {
    console.error('Error en la operación:', error)
    
    // Determinar el tipo de error y mostrar mensaje apropiado
    let errorMessage = 'Error al procesar la solicitud'
    
    if (error?.response?.status === 401) {
      errorMessage = 'Sesión expirada. Por favor, inicie sesión nuevamente'
    } else if (error?.response?.status === 403) {
      errorMessage = 'No tiene permisos para realizar esta operación'
    } else if (error?.response?.status === 404) {
      errorMessage = 'Recurso no encontrado'
    } else if (error?.response?.status >= 500) {
      errorMessage = 'Error del servidor. Por favor, intente más tarde'
    } else if (error?.message?.includes('Network Error')) {
      errorMessage = 'Error de conexión. Verifique su conexión a internet'
    }
    
    openAlert(errorMessage, 'error')
  }

  const handleSubmit = async e => {
    e.preventDefault()

    // Validar que no esté en proceso de carga
    if (isLoadingPost) {
      openAlert('Ya hay una operación en proceso', 'warning')
      return
    }

    // Validar datos del formulario
    const validationErrors = validateFormData()
    if (validationErrors.length > 0) {
      openAlert(validationErrors.join('. '), 'error')
      return
    }

    // Construir datos de la solicitud
    const requestData = buildRequestData()
    const serviceEndpoint = actionToBeCarriedOut === 'Edit'
      ? environment.UPDATE__DISPATCH_STATUS_CORRECTED_ITEM
      : environment.CREATE_DISPATCH_STATUS_CORRECTED_ITEM

    // Ejecutar la mutación
    mutate(
      {
        data: requestData,
        Endpoint: serviceEndpoint,
        PropertyBody: 'SENDJSONCONTENTPOST'
      },
      {
        onSuccess: handleSuccess,
        onError: handleError
      }
    )
  }

  const handleBlur = async data => {
    // Validar datos de búsqueda
    if (!data?.item && !data?.code && !data?.reference) {
      openAlert('Debe proporcionar al menos un criterio de búsqueda (item, código o referencia)', 'error')
      return
    }

    const sendDate = {
      item: data?.item || '',
      code: data?.code || '',
      date_start: data?.date_start || '',
      date_end: data?.date_end || '',
      reference: data?.reference || '',
      subheading: data?.subheading || '',
      description: data?.description || '',
      ...(props?.qualifiedUserId && { qualifiedUser_id: props?.qualifiedUserId })
    }

    mutate(
      {
        data: sendDate,
        Endpoint: environment.SEARCH_DISPACTH_FORM_EXIT,
        PropertyBody: 'SENDJSONCONTENTPOST'
      },
      {
        onSuccess: data => {
          const responseCode = data?.data?.status?.code
          const responseMessage = data?.data?.status?.message

          if (responseCode === 400) {
            openAlert(responseMessage || 'Error en la búsqueda', 'error')
            return
          }

          if (responseCode === 200) {
            openAlert(responseMessage || 'Búsqueda realizada exitosamente', 'success')
          } else {
            openAlert(responseMessage || 'Respuesta inesperada del servidor', 'error')
          }
        },
        onError: error => {
          console.error('Error en la búsqueda:', error)
          openAlert('Error al realizar la búsqueda. Por favor, intente nuevamente', 'error')
        }
      }
    )
  }

  const formItemsDispacth = () => {
    return (
      <SearchItemDispacth
        onClose={onCloseSearchItem}
        loading={isLoading}
        handleSearch={handleBlur}
      />
    )
  }

  useEffect(() => {
    if (actionToBeCarriedOut === 'Create') {
      setTargetData('')
      reset()
    }
  }, [actionToBeCarriedOut])

  /*   useEffect(() => {
    if (editType === 'Dispatch') setRenderingComponent(formItemsDispacth)
  }, [editType]) */

  return (
    <>
      <ItemSearchModal
        OnClose={onCloseSearchItem}
        isOpen={isOpenSearchItem}
        onOpen={onOpenSearchItem}
        qualifiedUserId={props.qualifiedUserId}
      />

      <form onSubmit={handleSubmit}>
        <Box>
          <InputGroup>
            <Input
              w={'100%'}
              h={'38px'}
              color={'#000'}
              outline={'none'}
              fontSize={'1rem'}
              backgroundColor={'#ffffff87'}
              name={'code_outputForm_corrected'}
              onChange={handleInputChange}
              value={values?.code_outputForm_corrected}
              placeholder={'Salida*'}
            />
            <InputRightElement onClick={onOpenSearchItem}>
              <RiSearch2Line color='green.500' />
            </InputRightElement>
          </InputGroup>

          <Flex gap={4} alignContent={'space-between'}>
            <Box w={'full'}>
              <FormInfo
                template={FormItemsTemplate}
                values={values}
                Actions={Action}
                onChange={handleRegex}
                mode='evaluate'
              />
            </Box>

            <Box w={'full'}>
              <FormInfo
                template={FormItemsTemplate}
                values={values}
                Actions={Action}
                isEdit={Action === 'Edit'}
                onChange={handleRegex}
              />
            </Box>
          </Flex>
        </Box>

        <Box
          display='flex'
          alignItems='center'
          marginTop={'20px'}
          justifyContent='flex-end'
          flexWrap={'wrap'}
        >
          <ButtonStyled
            bgColor={'#bababa'}
            onClick={() => setActionToBeCarriedOut('')}
          >
            Cancelar
          </ButtonStyled>
          <ButtonStyled type='submit'>
            {actionToBeCarriedOut === 'Edit' ? 'Editar' : 'Agregar'}
          </ButtonStyled>
        </Box>
      </form>
    </>
  )
}
